import Vue from 'vue';
import moment from 'moment';

Vue.filter('money', (value) => {
  if (value) {
    const replaced = parseFloat(value).toFixed(2).replace('.', ',');
    return `R$ ${replaced}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }
  return 'R$ 0,00';
});
// Descritivo de contrato: valores de sessão podem ter 3 casas (ex: R$ 0,042)
Vue.filter('moneyDescriptive', (value) => {
  if (value) {
    const number = parseFloat(value);
    const decimals = Math.round(number * 1000) % 10 !== 0 ? 3 : 2;
    const [integer, fraction] = number.toFixed(decimals).split('.');
    const thousands = integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return `R$ ${thousands},${fraction}`;
  }
  return 'R$ 0,00';
});
Vue.filter('cnpj', (value) => {
  if (value) {
    // Remove pontuação, preserva letras e dígitos
    const clean = value.replace(/[^0-9A-Za-z]/g, '');
    if (clean.length === 14) {
      return clean.replace(/([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})([0-9A-Za-z]{2})/, '$1.$2.$3/$4-$5');
    }
    return value;
  }
  return '-';
});
Vue.filter('cpf', (value) => {
  if (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
  return '-';
});
Vue.filter('phonenumber', (value) => {
  if (value) {
    if (value.length == 13) {
      return value.replace(/(\d{2})(\d{2})(\d{5})(\d{2})/g, '$1 $2 $3-$4');
    }
    if (value.length == 12) {
      return value.replace(/(\d{2})(\d{2})(\d{4})(\d{2})/g, '$1 $2 $3-$4');
    }
    if (value.length == 11) {
      return value.replace(/(\d{2})(\d{2})(\d{3})(\d{2})/g, '$1 $2$3-$4');
    }
  }
  return '-';
});

Vue.filter('date', (value) => {
  if (value && value !== '0000-00-00') {
    return moment(String(value)).format('DD/MM/YYYY');
  }
  return '-';
});

Vue.filter('datetime', (value) => {
  if (value && value !== '0000-00-00 00:00:00') {
    return moment(String(value)).format('DD/MM/YYYY H:mm:ss');
  }
  return '-';
});

Vue.filter('datetimeUtcToBr', (value) => {
  if (value && value !== '0000-00-00 00:00:00') {
    return moment.utc(String(value)).utcOffset(-3).format('DD/MM/YYYY HH:mm:ss');
  }
  return '-';
});

Vue.filter('datetimeMinuteUtcToBr', (value) => {
  if (value && value !== '0000-00-00 00:00:00') {
    return moment.utc(String(value)).utcOffset(-3).format('DD/MM/YYYY HH:mm');
  }
  return '-';
});

Vue.filter('month', (value) => {
  if (value && value != '0000-00-00') {
    return moment(String(value)).format('MM/YYYY');
  }
  return '-';
});
Vue.filter('cnae', (value) => {
  if (value) {
    return value.replace(/(\d{4})(\d{1})(\d{2})/g, '$1-$2/$3');
  }
  return '-';
});
Vue.filter('cep', (value) => {
  if (value) {
    return value.replace(/(\d{5})(\d{3})/g, '$1-$2');
  }
  return '-';
});
Vue.filter('invoice_history_status', (value) => {
  const status = {
    queued: 'Em fila',
    processing: 'Processando',
    finished: 'Finalizado',
    error: 'Erro',
  };
  return status[value];
});
Vue.filter('document_type', (document) => {
  if (document) {
    if (document.type === 'cnpj') {
      return 'CNPJ';
    }
    if (document.type === 'cpf') {
      return 'CPF';
    }
  }

  return 'Documento';
});
Vue.filter('audit_event', (event) => {
  if (event) {
    if (event === 'updated') {
      return 'Alterado';
    }
    if (event === 'cancelled_by_blocked_60_days') {
      return 'Cancelado por bloqueio de 60 dias';
    }
    if (event === 'updated_by_non_payment') {
      return 'Status alterado por inadimplência';
    }
    if (event === 'readjustment') {
      return 'Reajuste de Contrato';
    }
    if (event && event.startsWith('readjustment_percent_')) {
      const percentage = event.replace('readjustment_percent_', '').replace('.', ',');
      return `Reajuste de Contrato - ${percentage}%`;
    }
    if (event === 'created') {
      return 'Criado';
    }
    if (event === 'deleted') {
      return 'Excluído';
    }
    if (event === 'restored') {
      return 'Restaurado';
    }
  }

  return '-';
});
Vue.filter('audit_fields_contract', (fields) => {
  const defaultFields = {
    product_id: 'Produto',
    customer_id: 'Cliente',
    finish: 'Fim do contrato',
    start: 'Início do contrato',
    note: 'Observações',
    billing_method: 'Cobrar por',
    due_day: 'Dia vencimento',
    contract_type: 'Tipo contrato',
    due_in_days: 'Prazo de vencimento',
    price: 'Preços',
    amount: 'Quantidade',
    datas: 'Faixas, Valor mínimo/extra, Modo cobrança licença',
    change_reason: 'Motivo da alteração',
    change_reason_group_id: 'Grupo (Motivo de alteração)',
    status: 'Status',
    hired_by: 'Contratado por',
    grace_date: 'Data de carência',
    plan_id: 'Plano',
    note_chatbot: 'Informações chatbot',
    plan_type_id: 'Plano',
  };
  let fieldsString = '';
  for (const key of Object.entries(fields)) {
    let value = `${defaultFields[key[0]]}`;
    if (value.localeCompare('undefined') != 0) {
      fieldsString += `${value}, `;
    }
  }
  return fieldsString.length > 1 ? fieldsString.slice(0, -2) : '-';
});

Vue.filter('audit_fields_invoice', (fields) => {
  const defaultFields = {
    status: 'Status',
    price_extra: 'Valor extra',
    discount: 'Valor desconto',
    extra_reason_id: 'Motivo do valor extra',
    discount_reason_id: 'Motivo do desconto',
    note: 'Observações',
    due_date: 'Vencimento',
    invoice_external_id: 'Id Externo',
    cancellation: 'Cancelamento',
  };
  let fieldsString = '';
  for (const key of Object.entries(fields)) {
    fieldsString += `${defaultFields[key[0]]}, `;
  }
  return fieldsString.length > 1 ? fieldsString.slice(0, -2) : '-';
});

Vue.filter('audit_fields_plan', (fields) => {
  const defaultFields = {
    name: 'Nome',
    product_id: 'Produto',
    monthly_value: 'Valor da mensalidade',
    change_reason: 'Motivo da alteração',
    datas: 'Quantidade, valor por excedente',
  };
  let fieldsString = '';
  for (const key of Object.entries(fields)) {
    fieldsString += `${defaultFields[key[0]]}, `;
  }
  return fieldsString.length > 1 ? fieldsString.slice(0, -2) : '-';
});

Vue.filter('audit_fields_customer_groups', (fields) => {
  const defaultFields = {
    name: 'Nome',
    product_id: 'Produto',
    monthly_value: 'Valor da mensalidade',
    change_reason: 'Motivo da alteração',
    datas: 'Quantidade, valor por excedente',
  };
  let fieldsString = '';
  for (const key of Object.entries(fields)) {
    fieldsString += `${defaultFields[key[0]]}, `;
  }
  return fieldsString.length > 1 ? fieldsString.slice(0, -2) : '-';
});

Vue.filter('audit_fields_proposals', (fields) => {
  const defaultFields = {
    business_executive_id: 'Descrição',
    product_id: 'Produto',
    status_id: 'Status',
    segment_id: 'Segmento',
    size_id: 'Tamanho',
    name: 'Razão Social',
    co_name: 'Nome Fantasia',
    email: 'E-mail',
    document: 'Documento',
    proposal_date: 'Data',
    amount: 'Quantidade',
    extra: 'Valor Extra',
    fixed: 'Valor Fixo',
    minimal: 'Valor mínimo',
    package: 'Plano mensal'
  };
  let fieldsString = '';
  for (const key of Object.entries(fields)) {
    fieldsString += `${defaultFields[key[0]]}, `;
  }
  return fieldsString.length > 1 ? fieldsString.slice(0, -2) : '-';
});

Vue.filter('monthNames', (value) => {
  const months = {
    '0': 'Todos',
    '1': 'Janeiro',
    '2': 'Fevereiro',
    '3': 'Março',
    '4': 'Abril',
    '5': 'Maio',
    '6': 'Junho',
    '7': 'Julho',
    '8': 'Agosto',
    '9': 'Setembro',
    '10': 'Outubro',
    '11': 'Novembro',
    '12': 'Dezembro'
  };
  return months[String(value)] || '-';
});
